import { http } from "@/lib/api";

const loadScript = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export const payWithRazorpay = async (payment, bookingId) => {
  if (!(await loadScript())) throw new Error("Could not load Razorpay checkout");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: payment.key_id,
      amount: payment.amount,
      currency: "INR",
      order_id: payment.order_id,
      name: payment.name,
      description: payment.description,
      prefill: payment.prefill,
      theme: { color: "#E07A5F" },
      handler: async (res) => {
        try {
          await http.post("/payments/verify", { booking_id: bookingId, ...res });
          resolve("confirmed");
        } catch (e) {
          reject(e);
        }
      },
      modal: { ondismiss: () => resolve("dismissed") },
    });
    rzp.open();
  });
};
